export const Trasnsac_key = {
  transct_key: "520734b1-2320-478e-8c63-f9b84c09c617",
  environment: "STAGING",
};
